var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSave = function SvgIconSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M21.5 6.793V21.5h-19v-19h14.707zM3.5 20.5h4v-8h9v8h4V7.207L16.793 3.5H3.5zm5 0h7v-7h-7zm8-12h-9v-1h9z"
  })));
};
export default SvgIconSave;